<template>
  <simple-dropdown tabindex="-1">
    <template v-slot:dropdownMenu>
      <ul>
        <li v-if="createCompany">
          <a target="_blank" :href="createCompanyLink">Create Company</a>
        </li>
        <li v-if="createPerson">
          <a target="_blank" :href="createPersonLink">Create Person</a>
        </li>
        <li class="separator" v-if="(createCompany || createPerson) && (copyEntities || pasteEntities)"></li>
        <li v-if="copyEntities">
          <button @click="$emit('copyEntities')">Copy Entities</button>
        </li>
        <li v-if="pasteEntities">
          <button @click="$emit('pasteEntities')">Paste Entities</button>
        </li>
      </ul>
    </template>
  </simple-dropdown>
</template>

<script>
import SimpleDropdown from "@/components/SimpleDropdown";
import {createCompanyLink, createPersonLink} from "@/config/constants";

export default {
  name: "CreateEntityDropdown",
  components: {SimpleDropdown},
  data() {
    return {
      createCompanyLink,
      createPersonLink,
    }
  },
  props: {
    createCompany: {
      default: true
    },
    createPerson: {
      default: true
    },
    copyEntities: {
      default: true
    },
    pasteEntities: {
      default: true
    }
  }
}
</script>

<style scoped>

</style>
